export const FONT_FIT_REFERENCE = "Bounded";
export const PROBE_SIZE = 100;

export type FontScript = "cyrillic" | "latin";

export type FontCoverage = Record<FontScript | "digits", boolean>;

export const SCRIPT_GLYPHS: Record<FontScript, { sample: string; x: string; cap: string }> = {
	cyrillic: { sample: "Шаурма с курицей и сыром Добавить в корзину Оформить заказ ЖЩфДЮ", x: "х", cap: "Н" },
	latin: { sample: "Hamburger Cheese Combo Add to cart Checkout Wqjgy", x: "x", cap: "H" },
};

export const DIGITS_SAMPLE = "1 250 0123456789";

const COVERAGE_FALLBACKS = ["monospace", "serif", `"${FONT_FIT_REFERENCE}"`];
const COVERAGE_TOLERANCE = 0.5;
const VARIABLE_MIN_WIDTH_DELTA = 0.005;

let context: CanvasRenderingContext2D | null | undefined;

export const quoteFamily = (family: string) => (/[,"']/.test(family) ? family : `"${family}"`);

export const fontString = (family: string, weight = "400") => `${weight} ${PROBE_SIZE}px ${quoteFamily(family)}`;

export const textMetrics = (font: string, text: string): TextMetrics | null => {
	context ??= document.createElement("canvas").getContext("2d");
	if (!context) return null;
	context.font = font;
	return context.measureText(text);
};

const textWidth = (font: string, text: string) => textMetrics(font, text)?.width ?? 0;

const coversText = (family: string, text: string) => {
	const [first, ...others] = COVERAGE_FALLBACKS.map((fallback) => textWidth(`${PROBE_SIZE}px ${quoteFamily(family)}, ${fallback}`, text));
	return first > 0 && others.every((width) => Math.abs(width - first) < COVERAGE_TOLERANCE);
};

export const coverageOf = (family: string): FontCoverage => ({
	cyrillic: coversText(family, SCRIPT_GLYPHS.cyrillic.sample),
	latin: coversText(family, SCRIPT_GLYPHS.latin.sample),
	digits: coversText(family, DIGITS_SAMPLE),
});

export const primaryScript = (coverage: FontCoverage): FontScript | null => {
	if (coverage.cyrillic) return "cyrillic";
	return coverage.latin ? "latin" : null;
};

const coveredSample = (coverage: FontCoverage) =>
	[coverage.cyrillic && SCRIPT_GLYPHS.cyrillic.sample, coverage.latin && SCRIPT_GLYPHS.latin.sample, coverage.digits && DIGITS_SAMPLE]
		.filter(Boolean)
		.join(" ");

export const hasVariableWeight = (family: string) => {
	const sample = coveredSample(coverageOf(family));
	if (!sample) return false;
	const regular = textWidth(fontString(family, "400"), sample);
	const black = textWidth(fontString(family, "900"), sample);
	return regular > 0 && Math.abs(black - regular) / regular > VARIABLE_MIN_WIDTH_DELTA;
};
